export default "__VITE_ASSET__DZ1hTLR4__"